import {AsyncSsrManagerV1} from '@feature-hub/async-ssr-manager';
import {FeatureAppDefinition, FeatureServices, Logger} from '@feature-hub/core';
import {HistoryServiceV2} from '@feature-hub/history-service';
import {ReactFeatureApp} from '@feature-hub/react';
import {SerializedStateManagerV1} from '@feature-hub/serialized-state-manager';
import {ServerRequestV1} from '@feature-hub/server-request';
import {ApiKeyProviderV1} from '@volkswagen-onehub/api-key-provider';
import {BreadcrumbServiceV1} from '@volkswagen-onehub/breadcrumb-service';
import {ThemeProvider} from '@volkswagen-onehub/components-core';
import {DisclaimerManagerV1} from '@volkswagen-onehub/disclaimer-manager';
import {FaContentServiceV1} from '@volkswagen-onehub/fa-content-service';
import {LayerManagerV24} from '@volkswagen-onehub/layer-manager';
import {LocaleServiceV1} from '@volkswagen-onehub/locale-service';
import {PageInfoServiceV1} from '@volkswagen-onehub/page-info-service';
import {ServiceConfigProviderV1} from '@volkswagen-onehub/service-config-provider';
import React from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import SwiperCore from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import App from './app';
import './assets/css/global.css';
import dependencies from './dependencies.json';
import {FeatureServicesContext} from './use-feature-services';
import {GPSTourBrandExperiences, ScreenTypes} from './constants';
SwiperCore.use([Pagination, Navigation]);
export interface EvhubFeatureAppDependencies extends FeatureServices {
  readonly 'api-key-provider'?: ApiKeyProviderV1;
  readonly 'disclaimer-manager': DisclaimerManagerV1;
  readonly 'fa-content-service'?: FaContentServiceV1;
  readonly 'layer-manager': LayerManagerV24;
  readonly 'locale-service': LocaleServiceV1;
  readonly 's2:history': HistoryServiceV2;
  readonly 's2:logger'?: Logger;
  readonly 's2:server-request'?: ServerRequestV1;
  readonly 'service-config-provider': ServiceConfigProviderV1;
  readonly 'page-info-service': PageInfoServiceV1;
  readonly 'breadcrumb-service': BreadcrumbServiceV1;
  readonly 's2:serialized-state-manager': SerializedStateManagerV1;
  readonly 's2:async-ssr-manager': AsyncSsrManagerV1;
}

export type FeatureAppContent = {
  EV_SCREEN: ScreenTypes;
  EV_SURVEY_LANDING_URL?: string;
  EV_AMPOL_AMP_CHARGE_MODEL_NAME?: string;
  EV_SURVEY_AMPOL_AMP_CHARGE_URL?: string;
  EV_GPS_TOUR_BRANCH?: GPSTourBrandExperiences;
};

export const featureAppDefinition: FeatureAppDefinition<
  ReactFeatureApp,
  EvhubFeatureAppDependencies
> = {
  ...dependencies,

  create: (env) => {
    const {featureServices} = env;

    const {'fa-content-service': contentService} = featureServices;

    const featureAppContent = contentService?.content as FeatureAppContent;
    return {
      // eslint-disable-next-line react/display-name
      render: () => {
        return (
          <FeatureServicesContext.Provider value={featureServices}>
            <ThemeProvider theme="main">
              <Router>
                <App content={featureAppContent} />
              </Router>
            </ThemeProvider>
          </FeatureServicesContext.Provider>
        );
      },
    };
  },
};

export default featureAppDefinition;
